import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.promise.js";
// 深圳工行福利
import { passportUrl } from '../config/domain';
import { dateFormat } from '../utils/time/format';
export default {
  appName: 'shenzhen_icbc',
  useKNB: false,
  sellChannel: 35,
  // 渠道号
  theme: 'maoyan',
  hostPrefix: '//show.maoyan.com/qqw',
  hostBetaPrefix: '//show.test.maoyan.com/qqw',
  ajaxUrl: '//show.maoyan.com/maoyansh/myshow/ajax',
  ajaxBetaUrl: '//show.test.maoyan.com/maoyansh/myshow/ajax',
  tokenCookie: 'token',
  // 鉴权令牌
  linkMap: {
    // 地址跳转映射
    // 首页
    '/myshow/index.html': '/',
    '/myshow/': '/',
    '/movieshow/index.html': '/',
    // 列表相关
    '/movieshowlist/graphic-detail.html': '/graphic',
    '/movieshowlist/show-ticket.html': '/list',
    '/movieshowlist/show-merchant.html': '/merchants',
    '/movieshowlist/show-detail.html': '/detail',
    '/movieshowlist/group.html': '/group',
    '/movieshowlist/search.html': '/search',
    '/movieshowlist/show-shop.html': '/shop',
    // 下单相关
    '/movieshoworder/goods.html': '/tickets',
    '/movieshoworder/pre-order.html': '/confirm',
    '/movieshoworder/area.html': '/partition',
    '/movieshoworder/add-address.html': '/add-addr',
    '/movieshoworder/choose-address.html': '/choose-addr',
    '/movieshoworder/coupon-detail.html': '/coupon-detail',
    '/movieshoworder/seats.html': '/seats',
    '/movieshoworder/coupon.html': '/coupon',
    '/movieshoworder/order-detail.html': '/order-detail',
    '/movieshoworder/order-list.html': '/order-list',
    '/movieshoworder/real-names.html': '/realname',
    '/movieshoworder/seat-area.html': '/seat-area',
    '/movieshoworder/select-seats.html': '/select-seats',
    '/movieshoworder/search-order.html': '/search-order'
  },
  /**
   * @description 登录方法
   */
  login: function login() {
    try {
      var shenzhenIcbcParams = sessionStorage.getItem('shenzhenIcbcParams');
      var _ref = JSON.parse(shenzhenIcbcParams) || {},
        _ref$bankEncryKey = _ref.bankEncryKey,
        bankEncryKey = _ref$bankEncryKey === void 0 ? '' : _ref$bankEncryKey,
        _ref$bankEncryData = _ref.bankEncryData,
        bankEncryData = _ref$bankEncryData === void 0 ? '' : _ref$bankEncryData,
        _ref$bankSignMsg = _ref.bankSignMsg,
        bankSignMsg = _ref$bankSignMsg === void 0 ? '' : _ref$bankSignMsg;
      if (bankEncryKey && bankEncryData && bankSignMsg) {
        // 深圳工行参数
        var extraParams = "bankEncryData=".concat(encodeURIComponent(bankEncryData), "&bankEncryKey=").concat(encodeURIComponent(bankEncryKey), "&bankSignMsg=").concat(encodeURIComponent(bankSignMsg));

        // 联合登陆文档 https://doc.maoyan.com/product/passport/bankLogin?version=1.0.0
        var newTimeLog = "".concat(dateFormat(new Date(), 'yyyy-MM-dd hh:mm:ss.S'));
        var queryString = window.location.href.split('?');
        var params = new URLSearchParams(queryString[1]);

        // params.append("bankEncryKey", bankEncryKey);
        // params.append("bankEncryData", bankEncryData);
        // params.append("bankSignMsg", bankSignMsg);
        var redirectURL = "".concat(queryString[0], "?").concat(params.toString());
        // 跳转登录页面
        var url = "".concat(passportUrl, "/bankLogin?appName=shenzhen_icbc&plantform=show&").concat(extraParams, "&business=media&type=server&bankTimeLog=").concat(newTimeLog, "&redirectURL=").concat(encodeURIComponent(redirectURL));
        // 必须为maoyan.com下的子域名，否则cookie种不上，导致循环跳转
        if (location.hostname.indexOf('maoyan') >= 0) {
          location.href = url;
        } else {
          return Promise.reject(new Error('不支持当前域名'));
        }
      } else {
        return Promise.reject(new Error('参数解析出错'));
      }
    } catch (err) {
      return Promise.reject(new Error('小喵提醒您，请返回入口后再次进入'));
    }
  }
};